import React from "react"
import { Languages } from "../components/languages"
export default class UnauthorizedPage extends React.Component {
    constructor(props) {
        super(props);
        this.le = Languages.UnauthorizedPage[Languages.selectedLanguage];
    }
    render() {
        return (
            <div>
                <h2>{this.le.title}</h2>
                <p>{this.le.subtitle}</p>
            </div>
        )
    }
} 